<script setup>
import { formatNumber } from '@js/utils/formatter';

const {
    number1,
    number2 = undefined,
    number3 = undefined,
    withDecimals = false,
    color = null,
} = defineProps({
    number1: {
        type: [Number, String],
        required: true,
    },
    number2: {
        type: [Number, String],
        required: false,
    },
    number3: {
        type: [Number, String],
        required: false,
    },
    withDecimals: {
        type: Boolean,
        required: false,
    },
    color: {
        type: String,
        required: false,
    },
});
</script>

<template>
    <div
        class="flex h-full flex-col justify-center p-4"
        :class="{
            'bg-green-200 text-green-600': color === 'green',
            'bg-orange-200 text-orange-600': color === 'orange',
            'bg-red-200 text-red-600': color === 'red',
        }"
    >
        <div class="text-lg font-bold whitespace-nowrap">
            {{ formatNumber(number1, withDecimals) }}
        </div>

        <div
            v-if="number2 !== undefined && number2 !== null"
            class="whitespace-nowrap"
        >
            {{ formatNumber(number2, withDecimals) }}
        </div>

        <div
            v-if="number3 !== undefined && number3 !== null"
            class="whitespace-nowrap"
        >
            {{ formatNumber(number3, withDecimals) }}
        </div>
    </div>
</template>
